/*
  ft-buy.js — "Flatter · Satın alma" bölümünün (sections/ft-buybox.liquid) eklentisi.
  layout/theme.liquid içinde assets/v4.js'ten SONRA (defer) yüklenir. v4.js'e dokunmaz; onun kancalarını kullanır.
  ES5, bağımlılık yok. Sayfada [data-ft-buy] yoksa hiçbir şey yapmaz.

  1. Seçili paketi yansıtır: [data-ft-total] " · 679 TL", [data-ft-pack] "Ev + Yanında",
     [data-ft-was] "Tekli <s>718 TL</s>" (Tekli toplam yoksa paketin içerik satırı), [data-ft-line] hat görseli
     ve "Tüm paketler (6) · Seyahat, Avantajlı" butonu.
  2. Yapışkan bar (mobil): ana "Sepete ekle" ekranda tam görünmüyorsa açılır (kısa ekranlarda ilk yüklemede de);
     kapanış bölümü ([data-ft-close]) görünürken ya da satın alınabilir paket yokken kapanır.
  3. [data-ft-proxy-add] (ör. kapanış bölümündeki buton): v4_close_click olayı, sonra ana butona tıklar
     (v4.js sepete ekler, çekmeceyi açar, v4_add_click gönderir).
  4. [data-goto-line="koku-giderici"] ya da [data-goto-line="2"]: o hattı seçer ve satın alma kutusuna kaydırır.
     Adresteki #koku-giderici değişince (hashchange) de aynısı. (İlk açılıştaki ?urun= / # bölümdeki betikte.)
     Hattın kendi kategori sayfası varsa (seçicide başka sayfaya giden kart) o sayfaya gidilir.
  5. Seçilen kutu seçici satırında görünür olur (sadece yatay; sayfa kaydırılmaz).
  6. Tema editörü: bölüm yenilenince yeniden kurulur; editörde seçilen hat / paket / görsel öne getirilir.
  7. Ürün seçici kaydırılabiliyorsa ([data-ft-lines]): sağda/solda ok, sağ kenarda solma (CSS .is-scrollable / .is-end)
     ve oturumda bir kez, kullanıcı dokunmadan önce satırın kısa bir kayıp geri gelmesi (kaydırılabildiğini gösterir).
  8. Bağlantı menüsü (bir hattın kendi kategori sayfası varken seçici <nav>, kartlar <a data-line-link>):
     bu sayfadaki hattın kartı gizli v4.js sekmesini tıklatır (sayfa yenilenmez), seçili kart aria-current alır;
     başka sayfaya giden kart ([data-ft-cat]) v4_category_click olayını gönderir, sonra sayfa açılır.
  9. Ayrı "Kategori seçici" bölümü (sections/ft-catnav.liquid, [data-ft-catnav]): seçici kutunun dışında, bir ya da
     birkaç yerde. Kopyalar sayfadaki ilk satın alma kutusuna bağlıdır (8 ile aynı davranış). Kopyalamayı
     snippets/ft-buy-lines'taki window.ftCatNavFill yapar; tema editöründe bölüm yenilenince / eklenince buradan
     çağrılır. Ayar "Ayrı bölümde" iken sayfada bölüm yoksa seçici kutunun üstüne konur ([data-ft-lines-spare]).
*/
(function () {
  'use strict';

  var reduceMotion = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);

  function all(scope, selector) {
    return [].slice.call(scope.querySelectorAll(selector));
  }
  function money(cents) {
    return window.v4FormatMoney ? window.v4FormatMoney(cents) : Math.round(cents / 100) + ' TL';
  }
  function roots() {
    return all(document, '[data-ft-buy]');
  }
  function checkedRadio(root) {
    return root.querySelector('input[name=id]:checked:not(:disabled)');
  }
  function currentLine(root) {
    var tab = root.querySelector('[data-line-tab][aria-selected="true"]');
    if (tab) return tab.getAttribute('data-line-tab');
    var radio = checkedRadio(root);
    var pack = radio && radio.closest('.v4-pack');
    return pack ? pack.getAttribute('data-line') : '1';
  }
  /* Hat: sıra numarası ("2") ya da bağlantı adı ("koku-giderici"). Yakında hatların sekmesi yoktur → null. */
  function findTab(root, value) {
    value = String(value || '').toLowerCase();
    if (!value) return null;
    return all(root, '[data-line-tab]').filter(function (tab) {
      return tab.getAttribute('data-line-tab') === value || tab.getAttribute('data-line-handle') === value;
    })[0] || null;
  }
  /* Seçicideki bağlantı kartları: kutunun içindekiler + (sayfadaki ilk kutu için) ayrı Kategori seçici bölümlerindekiler */
  function navCards(root) {
    var cards = all(root, '[data-line-link]');
    if (root === roots()[0]) cards = cards.concat(all(document, '[data-ft-catnav] [data-line-link]'));
    return cards;
  }
  /* Hattın kendi sayfasına giden kart (bağlantı menüsü, [data-ft-cat]); yoksa null */
  function pageCard(root, value) {
    value = String(value || '').toLowerCase();
    if (!value) return null;
    return navCards(root).filter(function (card) {
      return card.hasAttribute('data-ft-cat') &&
        (card.getAttribute('data-line-link') === value || card.getAttribute('data-line-handle') === value);
    })[0] || null;
  }
  /* Bölüm dışındaki [data-ft-*] öğeleri sayfadaki ilk satın alma kutusunu izler. */
  function targets(root, selector) {
    var first = roots()[0];
    return all(document, selector).filter(function (el) {
      var section = el.closest('section');
      var owner = section && section.querySelector('[data-ft-buy]');
      return owner ? owner === root : root === first;
    });
  }

  /* 5 ─ seçili kutuyu seçici satırında görünür yap */
  function reveal(tab) {
    var track = tab && tab.parentNode;
    if (!track || track.scrollWidth <= track.clientWidth) return;
    var left = tab.offsetLeft - (parseFloat(window.getComputedStyle(track).paddingLeft) || 0);
    if (track.scrollTo) track.scrollTo({ left: left, behavior: reduceMotion ? 'auto' : 'smooth' });
    else track.scrollLeft = left;
  }
  /* Hattın görünen kartları (bağlantı menüsü: <a data-line-link>, kutuda ya da ayrı bölümlerde); yoksa sekmenin kendisi */
  function revealLine(root, tab) {
    var line = tab && tab.getAttribute('data-line-tab');
    var cards = navCards(root).filter(function (card) { return card.getAttribute('data-line-link') === line; });
    if (!cards.length) cards = [tab];
    cards.forEach(reveal);
  }

  /* 1 ─ seçili paketi yansıt */
  function labelMore(root, line) {
    var more = root.querySelector('[data-more]');
    if (!more) return;
    var packs = all(root, '.v4-pack').filter(function (pack) { return pack.getAttribute('data-line') === line; });
    var names = packs.filter(function (pack) { return pack.hidden; }).map(function (pack) {
      var name = pack.querySelector('.ft-pack__name');
      return name ? name.textContent : '';
    });
    var label = more.querySelector('[data-more-label]');
    var rest = more.querySelector('[data-more-names]');
    if (label) label.textContent = (more.getAttribute('data-label') || '').replace('{count}', packs.length);
    if (rest) rest.textContent = names.length ? '· ' + names.join(', ') : '';
  }

  function sync(root) {
    var line = currentLine(root);
    labelMore(root, line);
    navCards(root).forEach(function (card) {
      if (card.getAttribute('data-line-link') !== line) card.removeAttribute('aria-current');
      else if (!card.hasAttribute('aria-current')) card.setAttribute('aria-current', 'true');
    });
    all(root.closest('section') || document, '[data-ft-line]').forEach(function (el) {
      el.hidden = el.getAttribute('data-ft-line') !== line;
    });

    var radio = checkedRadio(root);
    if (!radio) return;
    var price = parseInt(radio.getAttribute('data-price'), 10) || 0;
    var tekli = parseInt(radio.getAttribute('data-compare'), 10) || 0;
    var pack = radio.closest('.v4-pack');
    var nameEl = pack && pack.querySelector('.ft-pack__name');
    var name = nameEl ? nameEl.textContent.trim() : (radio.getAttribute('data-name') || '').split(' · ')[0];
    var prefix = root.getAttribute('data-compare-prefix') || '';

    targets(root, '[data-ft-total]').forEach(function (el) { el.textContent = ' · ' + money(price); });
    targets(root, '[data-ft-pack]').forEach(function (el) { el.textContent = name; });
    targets(root, '[data-ft-was]').forEach(function (el) {
      el.textContent = '';
      if (tekli > price) {
        if (prefix) el.appendChild(document.createTextNode(prefix + ' '));
        var struck = document.createElement('s');
        struck.textContent = money(tekli);
        el.appendChild(struck);
      } else {
        el.textContent = radio.getAttribute('data-sub') || '';
      }
    });
  }

  /* 2 ─ yapışkan bar */
  function watchSticky(root, state) {
    var section = root.closest('section') || document;
    var bar = section.querySelector('[data-v4-sticky]');
    var add = root.querySelector('[data-add]');
    if (!bar || !add || !('IntersectionObserver' in window)) return;

    var ctaFullyVisible = true;
    var closing = [];
    state.paint = function () {
      var closingOn = closing.some(function (el) { return el.__ftCloseOn && document.documentElement.contains(el); });
      var on = !ctaFullyVisible && !closingOn && !add.disabled;
      bar.setAttribute('data-ft', on ? 'on' : 'off');
      bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      var button = bar.querySelector('[data-sticky-add]');
      if (button) button.tabIndex = on ? 0 : -1;
    };
    new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { ctaFullyVisible = entry.intersectionRatio >= 0.98; });
      window.requestAnimationFrame(state.paint);
    }, { threshold: [0, 0.5, 0.98, 1] }).observe(add);

    var closeObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) { entry.target.__ftCloseOn = entry.isIntersecting; });
      window.requestAnimationFrame(state.paint);
    });
    /* Kapanış bölümü sonradan eklenebilir (tema editörü) → her bölüm yüklemesinde yeniden taranır */
    state.watchClosing = function () {
      all(document, '[data-ft-close]').forEach(function (el) {
        if (closing.indexOf(el) >= 0) return;
        closing.push(el);
        closeObserver.observe(el);
      });
    };
    state.watchClosing();
  }

  /* 7 ─ ürün seçici: oklar ve kaydırma ipucu (lines: [data-ft-lines] öğesi; kutuda ya da ayrı bölümde) */
  function watchLines(lines) {
    var track = lines && lines.querySelector('.ft-buy__track');
    if (!track || lines.__ftLines) return;
    lines.__ftLines = true;
    var prev = lines.querySelector('[data-ft-lines-go="-1"]');
    var next = lines.querySelector('[data-ft-lines-go="1"]');
    var touched = false;
    function update() {
      var max = track.scrollWidth - track.clientWidth;
      var scrollable = max > 4;
      var atEnd = track.scrollLeft >= max - 4;
      lines.classList.toggle('is-scrollable', scrollable);
      lines.classList.toggle('is-end', scrollable && atEnd);
      if (prev) prev.hidden = !scrollable || track.scrollLeft <= 4;
      if (next) next.hidden = !scrollable || atEnd;
    }
    function go(dir) {
      touched = true;
      var step = Math.max(track.clientWidth * 0.7, 120) * dir;
      if (track.scrollBy) track.scrollBy({ left: step, behavior: reduceMotion ? 'auto' : 'smooth' });
      else track.scrollLeft += step;
    }
    if (prev) prev.addEventListener('click', function () { go(-1); });
    if (next) next.addEventListener('click', function () { go(1); });
    track.addEventListener('scroll', function () { window.requestAnimationFrame(update); }, { passive: true });
    ['pointerdown', 'touchstart', 'wheel', 'keydown'].forEach(function (type) {
      track.addEventListener(type, function () { touched = true; }, { passive: true });
    });
    window.addEventListener('resize', update);
    update();

    /* İpucu: oturumda bir kez, satır görünürken ve kullanıcı henüz dokunmadıysa 56 px kayıp geri gelir */
    if (reduceMotion || !track.scrollTo) return;
    try { if (window.sessionStorage.getItem('ftLinesHint')) return; } catch (e) { /* gizli mod: yine de göster */ }
    window.setTimeout(function () {
      var rect = track.getBoundingClientRect();
      if (touched || track.scrollLeft > 4 || track.scrollWidth - track.clientWidth < 24) return;
      if (rect.bottom < 0 || rect.top > window.innerHeight) return;
      try { window.sessionStorage.setItem('ftLinesHint', '1'); } catch (e) { /* yok say */ }
      var snap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      track.scrollTo({ left: 56, behavior: 'smooth' });
      window.setTimeout(function () {
        if (!touched) track.scrollTo({ left: 0, behavior: 'smooth' });
        window.setTimeout(function () { track.style.scrollSnapType = snap; }, 500);
      }, 650);
    }, 1200);
  }

  /* 4 ─ hattı seç + kutuya kaydır */
  function choose(tab) {
    var root = tab.closest('[data-ft-buy]');
    if (tab.getAttribute('aria-selected') === 'true') {
      if (root) revealLine(root, tab);
      else reveal(tab);
    } else {
      tab.click(); /* v4.js hattı değiştirir ve v4_tab_change gönderir; aşağıdaki dinleyici gerisini yapar */
    }
  }
  function scrollToModule(root) {
    var target = root.closest('[id]') || root;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  /* 3 ─ başka bölümdeki "Sepete ekle" */
  function proxyAdd(root, event) {
    var add = root.querySelector('[data-add]');
    if (!add) return;
    event.preventDefault();
    if (add.disabled) {
      var firstTab = root.querySelector('[data-line-tab]');
      if (firstTab) firstTab.click();
    }
    var radio = checkedRadio(root);
    if (window.v4Track) window.v4Track('v4_close_click', { pack: radio ? radio.getAttribute('data-name') || '' : '' });
    if (add.disabled) scrollToModule(root);
    else add.click();
  }

  /* 8 ─ bağlantı menüsündeki kart tıklaması */
  function onCard(root, card, event) {
    if (card.hasAttribute('data-ft-cat')) {
      var name = card.querySelector('.ft-sr');
      if (window.v4Track) {
        window.v4Track('v4_category_click', {
          line: card.getAttribute('data-line-link'),
          line_name: name ? name.textContent.trim() : '',
          url: card.getAttribute('href') || ''
        });
      }
      return;
    }
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || event.button > 0) return;
    var tab = findTab(root, card.getAttribute('data-line-link'));
    if (!tab) return;
    event.preventDefault();
    choose(tab);
  }

  /* 9 ─ "Ayrı bölümde" ayarı varken sayfada Kategori seçici bölümü yoksa seçiciyi kutunun üstüne koy */
  function spareNav(root) {
    var src = root.querySelector('template[data-ft-lines-src]');
    if (!src || document.querySelector('[data-ft-catnav]') || root.querySelector('[data-ft-lines-spare]')) return;
    var holder = document.createElement('div');
    holder.setAttribute('data-ft-lines-spare', '');
    holder.appendChild(src.content.cloneNode(true));
    src.parentNode.insertBefore(holder, src.nextSibling);
    all(holder, '[data-ft-lines]').forEach(watchLines);
  }
  /* window.ftCatNavFill kopyaladıktan sonra çağırır: yeni kopyaların okları ve seçili kartı */
  window.ftBuyNav = function () {
    all(document, '[data-ft-catnav] [data-ft-lines]').forEach(watchLines);
    var root = roots()[0];
    if (root && root.__ftBuy) sync(root);
  };

  function init(scope) {
    all(scope, '[data-ft-buy]').forEach(function (root) {
      if (root.__ftBuy) return;
      var state = { paint: function () {}, watchClosing: function () {} };
      root.__ftBuy = state;
      root.addEventListener('change', function () {
        sync(root);
        state.paint();
      });
      all(root, '[data-line-tab]').forEach(function (tab) {
        tab.addEventListener('click', function () {
          window.setTimeout(function () {
            sync(root);
            state.paint();
            revealLine(root, tab);
          }, 0);
        });
      });
      spareNav(root);
      watchSticky(root, state);
      all(root, '[data-ft-lines]').forEach(watchLines);
      sync(root);
    });
    all(document, '[data-ft-catnav] [data-ft-lines]').forEach(watchLines);
  }

  function closest(target, selector) {
    return target && target.closest ? target.closest(selector) : null;
  }

  document.addEventListener('click', function (event) {
    var card = closest(event.target, 'a[data-line-link]');
    if (!card) return;
    var root = closest(card, '[data-ft-buy]') || (closest(card, '[data-ft-catnav]') ? roots()[0] : null);
    if (root) onCard(root, card, event);
  });

  /* Yakalama aşaması: kapanış butonu genelde <a href="#satin-al">; v4.js'in #çapa kaydırması çalışırsa
     çekmece açılırken sayfa satın alma kutusuna zıplar. Olay burada durdurulur. */
  document.addEventListener('click', function (event) {
    var el = closest(event.target, '[data-ft-proxy-add]');
    var root = roots()[0];
    if (!el || !root) return; /* kutu bu sayfada yoksa link normal çalışır */
    event.stopPropagation();
    proxyAdd(root, event);
  }, true);

  /* Yakalama aşaması: kendi kategori sayfası olan hatta [data-goto-line] o sayfaya gider; v4.js'in #çapa kaydırması
     (ve adrese #satin-al yazması) çalışmasın diye olay burada durdurulur. */
  document.addEventListener('click', function (event) {
    var el = closest(event.target, '[data-goto-line]');
    var root = roots()[0];
    if (!el || !root || findTab(root, el.getAttribute('data-goto-line'))) return;
    var away = pageCard(root, el.getAttribute('data-goto-line'));
    if (!away) return;
    event.preventDefault();
    event.stopPropagation();
    away.click(); /* v4_category_click + kategori sayfası */
  }, true);

  document.addEventListener('click', function (event) {
    var el = closest(event.target, '[data-goto-line]');
    var root = roots()[0];
    if (!el || !root) return;
    var tab = findTab(root, el.getAttribute('data-goto-line'));
    if (!tab) return; /* yakında, bilinmeyen ya da kendi sayfası olan hat (aşağıda): link normal çalışsın */
    event.preventDefault();
    choose(tab);
    scrollToModule(root);
  });

  window.addEventListener('hashchange', function () {
    var root = roots()[0];
    if (!root) return;
    var hash = '';
    try { hash = decodeURIComponent(window.location.hash.slice(1)); } catch (e) { return; }
    var tab = findTab(root, hash);
    var away = tab ? null : pageCard(root, hash);
    if (away) away.click();
    if (!tab) return;
    choose(tab);
    scrollToModule(root);
  });

  /* 6 ─ tema editörü */
  window.addEventListener('shopify:section:load', function (event) {
    /* yakalama aşaması: v4.js bölümü kurmadan önce (masaüstü paket sayısı, seçili hat) */
    if (!window.ftBuyPrep) return;
    all(event.target, '[data-ft-buy]').forEach(function (root) { window.ftBuyPrep(root); });
  }, true);
  document.addEventListener('shopify:section:load', function (event) {
    if (window.ftCatNavFill) window.ftCatNavFill();
    init(event.target);
    roots().forEach(function (root) {
      if (root.__ftBuy) root.__ftBuy.watchClosing();
    });
  });
  /* Kategori seçici bölümü silinince: başka kopya yoksa seçici kutunun üstüne döner */
  document.addEventListener('shopify:section:unload', function () {
    window.setTimeout(function () {
      roots().forEach(function (root) {
        spareNav(root);
        if (root.__ftBuy) sync(root);
      });
    }, 0);
  });
  document.addEventListener('shopify:block:select', function (event) {
    var el = event.target;
    var root = closest(el, '[data-ft-buy]') || (closest(el, '[data-ft-catnav]') ? roots()[0] : null);
    if (!root) return;
    var line = el.getAttribute('data-line-tab') || el.getAttribute('data-line-link') || el.getAttribute('data-line');
    var tab = line && line !== '0' ? findTab(root, line) : null;
    if (tab) choose(tab);
    /* "Tüm paketler" altında kalan paket seçildiyse listeyi aç */
    if (el.classList.contains('v4-pack')) {
      window.setTimeout(function () {
        var more = root.querySelector('[data-more]');
        if (el.hidden && more && !more.hidden) more.click();
      }, 0);
    }
    var slide = el.getAttribute('data-slide');
    var thumb = slide ? root.querySelector('[data-thumb="' + slide + '"]') : null;
    if (thumb) window.setTimeout(function () { thumb.click(); }, 60);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
})();
